import {loader} from "./scripts/loader";
import {init_phone} from "./scripts/phone";

if ($('#contact-form').length) {
    $('#contact-form').submit(function (e){
        e.preventDefault();
        let formData = new FormData($(this)[0]);

        formData.append('action', 'contact_form_submit');
        formData.append('_ajax_nonce', window.glob_obj.contact_form_submit_nonce);
        $.ajax({
            type: "POST",
            url: window.glob_obj.ajaxurl,
            data: formData,
            processData: false,
            contentType: false,
            dataType: "json",
            beforeSend: function(){
                $('#contact-form .form-error').remove();
                loader.show()
            },
            success: function(data, textStatus, jqXHR) {
                loader.hide()

                if (data.errors){
                    const errors = data.errors
                    const keys = ['name', 'phone'];
                    Object.keys(errors).map(function(key, index) {
                        if (keys.includes(key)){
                            $(`#contact-form input[name=${key}], #contact-form select[name=${key}], #contact-form textarea[name=${key}]` ).closest('.form-group').append('<span class="form-error">' + errors[key] + '</span>');
                        } else {
                            $('<span class="form-error">' + errors[key] + '</span>').insertAfter(
                                $(`#contact-form input[name=${key}], #contact-form select[name=${key}], #contact-form textarea[name=${key}]`)
                            );
                        }
                    });
                    if (data.errors.global){
                        $('<p class="form-error">' + data.errors.global + '</p>').insertAfter($('#contact-form > fieldset'));
                    }
                }

                if (data.success) {
                    $('#contact-form').html('Thank You! The Applywave team will be in touch soon.');
                }
            },
            error: function(data, textStatus, jqXHR) {
                loader.hide()
                console.log(error);
            },
        })
    })
    init_phone();
}